import { render, staticRenderFns } from "./ListaInteresse.vue?vue&type=template&id=639e9029&"
import script from "./ListaInteresse.vue?vue&type=script&lang=js&"
export * from "./ListaInteresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports